// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yHZxfeMcKQJG1Ogm3jQs{display:flex;flex-direction:column;gap:4px;height:auto;min-height:fit-content;padding:8px 0}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/ui/OptionItem/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,OAAA,CACA,WAAA,CACA,sBAAA,CACA,aAAA","sourcesContent":[".optionWrap {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  height: auto;\n  min-height: fit-content;\n  padding: 8px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optionWrap": `yHZxfeMcKQJG1Ogm3jQs`
};
export default ___CSS_LOADER_EXPORT___;
